import { api } from "@/services/api"
import { useQuery } from "@tanstack/react-query"
import { useUser } from "../stores/use-user"
import { useEffect } from "react"

export function useGetLifeUsage() {
  const { setLifeUsage } = useUser()
  const query = useQuery({
    queryKey: ["get-life-usage"],
    queryFn: () => api.user.lifeUsage.get(),
  })

  useEffect(() => {
    if (query.isSuccess) {
      setLifeUsage(query.data.data.usages)
    }
  }, [query.status])

  return query
}
